import axios from 'axios'

// 查询当前用户的所有身份
export const getMyIdentities = () =>
  axios.get('/api/credits/identities')

// 查询指定身份的碱基币流水
export const getCreditLogs = (params) =>
  axios.get('/api/credits/logs', { params })

// 查询当前用户所有身份的碱基币流水
export const getAllCreditLogs = (params) =>
  axios.get('/api/credits/logs/all', { params })
